import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import I18n from "vue-i18n";
import LocaleZh from "./locales/zh-CN";
import LocaleEn from "./locales/en-US";

// ant-design
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.less";

// font
import "./assets/fonts/avenir/fonts.css";

// markdown
import "github-markdown-css/github-markdown.css";

Vue.config.productionTip = false;

Vue.use(Antd);
Vue.use(I18n);

// 国际化配置
const i18n = new I18n({
  locale: "zh-CN", // 语言标识, 通过切换locale的值来实现语言切换, this.$i18n.locale
  messages: {
    "zh-CN": LocaleZh, // 中文语言包
    "en-US": LocaleEn, // 英文语言包
  },
});

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
